<template>
  <div id="app">
        <router-view  @getToken="refreshToken"></router-view>
  </div>
</template>

<script>
	import {rechargeParam} from './assets/js/common.js'
	
	export default {
	  name: 'App',
	  	created(){
	  		
	  	},
	  	methods:{
	  		refreshToken(){

				let UA = navigator.userAgent.toLowerCase();
				if(/(ylkids_android)/.test(UA)) {
					// let str3 = window.jsInterface.GetToken();
					// localStorage.setItem("token", str3);
					window.jsInterface.tokenTnvalid();
				} else if(/(ios1.1.0)/.test(UA)) {
					window.webkit.messageHandlers.getIosToken.postMessage({method:"tokenTnvalid"});

				}else{
					this.$http.get("/api/v2/auth/refresh?"+rechargeParam({
					params:{
//						token:localStorage.getItem("token")
					}
				},false,true)).then((response) => {
					if(response.data.error == 0){
						localStorage.setItem("token",response.data.data);
						location.reload();
					}else if(response.data.error == "11002"){
						
					}else{
//						alert(response.data.msg);
						
					}
				})
				}

	  		}
	  	}
	}
</script>

<style>
	#app {
		position: relative;
	  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  width: 100%;
	  height: 100%;
		max-width: 7.6rem;
    margin: 0 auto;
	}

</style>



// WEBPACK FOOTER //
// src/App.vue